import React, {useState,useEffect} from "react";
import { useTranslate } from 'react-redux-multilingual';
import axios from 'axios'
import swal from "sweetalert2";

const useLoadArticleLists = () => {
    const t = useTranslate();
    const [loadingList,setLoadingList] = useState(true)
    const [articleLists,setArticleLists] = useState([])

    useEffect(function () {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/wms/article_list/list/1000/1"
            ).then((response) => {
                setArticleLists(response.data.datas)
            }).catch((error) => {
                if(error=='end_session') return;
                let messageError = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
                swal.fire(t(messageError), "", "error");
            })
            setLoadingList(false)
        })()
    }, [])

    return [loadingList,articleLists]
}

// Formulaire réutilisable pour attribuer/dupliquer une configuration de suppléments en s'appuyant sur une ArticleList (WMS) déjà existante
const ArticleListAssociationForm = (props) => {
    const t = useTranslate();
    const [loadingList,articleLists] = useLoadArticleLists()
    const [selectedArticleListId,setSelectedArticleListId] = useState('')
    const [action,setAction] = useState('ajout')
    const [submitting,setSubmitting] = useState(false)

    const handleSubmit = async () => {
        if(!selectedArticleListId) return;

        setSubmitting(true)
        const response = await axios.post(process.env.REACT_APP_API_URL+props.url,{
            article_list: selectedArticleListId,
            action: action
        }).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }
            else{
                swal.fire({
                    icon: 'success',
                    title: t('successOperation')
                })
                setSelectedArticleListId('')
                if(props.onSuccess) props.onSuccess()
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let messageError = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(messageError), "", "error");
        })
        setSubmitting(false)
    }

    return (
        <div className="row">
            <div className="col-12 col-lg-5 form-group">
                <label>{t('existingArticleList')}</label>
                <select
                    className="form-control"
                    disabled={loadingList || submitting}
                    value={selectedArticleListId}
                    onChange={(e)=>setSelectedArticleListId(e.target.value)}
                >
                    <option value="">-- Select --</option>
                    {articleLists.map(value=>
                        <option key={value.id} value={value.id}>{value.name}</option>
                    )}
                </select>
            </div>
            <div className="col-12 col-lg-4 form-group">
                <label>{t('actionOnExistingListItem')}</label>
                <select
                    className="form-control"
                    disabled={submitting}
                    value={action}
                    onChange={(e)=>setAction(e.target.value)}
                >
                    <option value="ajout">{t('addToTheSelection')}</option>
                    <option value="remplacement">{t('replaceTheList')}</option>
                </select>
            </div>
            <div className="col-12 col-lg-3 d-flex align-items-end form-group">
                <button
                    className="btn btn-primary"
                    disabled={submitting || !selectedArticleListId}
                    onClick={()=>handleSubmit()}
                >
                    {submitting ? <div className="spinner-border spinner-border-sm"></div> : t('btnValidate')}
                </button>
            </div>
        </div>
    )
}

export default ArticleListAssociationForm;
